import React, {useState} from "react";
import ReactPaginate from "react-paginate";
import CircularProgress from "@mui/material/CircularProgress";

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { t } from '../../content';

function TeamList({teamsData, selectedTeamHash, onSelectedFunction, isLoadingSingleTeam}) {
    const [searchTerm, setSearchTerm] = useState("");

    const [pageNumber, setPageNumber] = useState(0);
    const itemsPerPage = 10;
    const pagesVisited = pageNumber * itemsPerPage;

    const pageCount = Math.ceil(teamsData.length / itemsPerPage);
    const changePage = ({selected}) => {
        setPageNumber(selected);
    }

    const filteredTeams = teamsData.filter((team) => {
        if(team.members && team.members.length > 0){
            return team.members.some((member) =>
                member.email.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }else{
            return team;
        }
    });

    const displayItems = filteredTeams.slice(pagesVisited, pagesVisited + itemsPerPage);

    return (
        <div id="top" className="teams-items">
            <AppBar position="static" color="default" sx={{ boxShadow: "none" }}>
            <Toolbar>
                <SearchIcon />
                <InputBase
                    placeholder={t('common.placeholders.searchTeamMemberEmail')}
                    inputProps={{ "aria-label": t('common.labels.search') }}
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </Toolbar>
            </AppBar>
            <div className="teams-wrapper">{displayItems.map((team, index) => (
                <button
                    id={team.id}
                    className={selectedTeamHash === team.hash ? 'team active' : 'team'}
                    key={index}
                    onClick={()=> {onSelectedFunction(team.hash)}}
                >
                    <p className="team-title m-0 bottom bold m">{team.title}</p>

                    <div className="team-count">
                        <p className="light m-0">{t('teams.memberCount', { count: team.memberCount })}</p>
                    </div>
                    {selectedTeamHash === team.hash && isLoadingSingleTeam && 
                        <div>
                            <CircularProgress color="success" size="25px" />
                        </div>
                    }
                </button>
            ))}</div>
            {displayItems.length > 1 && (
            <ReactPaginate
                previousLabel={"PREV"}
                nextLabel={"NEXT"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"pagination"}
                previousLinkClassName={"prevBtn"}
                nextLinkClassName={"nextBtn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"}
                pageClassName={"pagination-item"}
            />
            )}
        </div>
    )
}

export default TeamList;
